export const useDates = () => {
  const parseTimestamp = (timestampString) => {
    const date = new Date(parseInt(timestampString));
    return date.toLocaleString("en-GB");
  };

  const ordinalSuffix = (day) => {
    if (day > 3 && day < 21) {
      return "th";
    }

    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const formatFriendlyDate = (timestampString) => {
    const date = new Date(parseInt(timestampString));
    const weekday = date.toLocaleDateString("en-GB", { weekday: "short" });
    const month = date.toLocaleDateString("en-GB", { month: "short" });
    const day = date.getDate();
    return `${weekday} ${day}${ordinalSuffix(day)} ${month}`;
  };

  const formatFriendlyTime = (timestampString) => {
    const date = new Date(parseInt(timestampString));
    return date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const actionAllowedBasedOnDate = (deadlineDateString) => {
    const deadlineDate = new Date(parseInt(deadlineDateString));
    const nowDate = new Date();

    if (nowDate <= deadlineDate) {
      return true;
    }

    return false;
  };

  return {
    parseTimestamp,
    formatFriendlyDate,
    formatFriendlyTime,
    actionAllowedBasedOnDate,
  };
};
